/* ==========================================================================
   MONA COLLECTION — grid toggle, filter drawer, sort, type dropdown
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-mona-collection]');
  if (!root) return;
  var body = document.body;

  /* ---- Grid toggle (persisted) ---- */
  var container = root.querySelector('[data-mona-grid-container]');
  var gridBtns = root.querySelectorAll('[data-mona-grid]');
  var GKEY = 'mona-grid-pref';

  function applyGrid(cols) {
    if (!container) return;
    container.classList.remove('mona-grid--1', 'mona-grid--2');
    container.classList.add('mona-grid--' + cols);
    gridBtns.forEach(function (b) {
      var on = b.getAttribute('data-mona-grid') === cols;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  try { var saved = localStorage.getItem(GKEY); if (saved && gridBtns.length) applyGrid(saved); } catch (e) {}
  gridBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var cols = b.getAttribute('data-mona-grid');
      applyGrid(cols);
      try { localStorage.setItem(GKEY, cols); } catch (e) {}
    });
  });

  /* ---- Sort ---- */
  var sort = root.querySelector('[data-mona-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---- Type dropdown ---- */
  var typedrop = root.querySelector('[data-mona-typedrop]');
  if (typedrop) {
    var tToggle = typedrop.querySelector('[data-mona-typedrop-toggle]');
    var tPanel = typedrop.querySelector('.mona-fb-dropdown__panel');
    tToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = tPanel.hasAttribute('hidden');
      if (open) { tPanel.removeAttribute('hidden'); tToggle.setAttribute('aria-expanded', 'true'); }
      else { tPanel.setAttribute('hidden', ''); tToggle.setAttribute('aria-expanded', 'false'); }
    });
    document.addEventListener('click', function (e) {
      if (!typedrop.contains(e.target)) { tPanel.setAttribute('hidden', ''); tToggle.setAttribute('aria-expanded', 'false'); }
    });
  }

  /* ---- Filter drawer ---- */
  var drawer = root.querySelector('[data-mona-filter-drawer]');
  var overlay = root.querySelector('[data-mona-filter-overlay]');
  var openBtn = root.querySelector('[data-mona-filter-open]');
  var closeBtn = root.querySelector('[data-mona-filter-close]');
  var applyBtn = root.querySelector('[data-mona-filter-apply]');
  var form = root.querySelector('[data-mona-filter-form]');

  function openDrawer() {
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    body.classList.add('mona-no-scroll');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 80);
  }
  function closeDrawer() {
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
    body.classList.remove('mona-no-scroll');
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  function applyFilters() {
    if (!form) return;
    var params = new URLSearchParams();
    var data = new FormData(form);
    data.forEach(function (value, key) { if (value !== '') params.append(key, value); });
    var qs = params.toString();
    window.location.href = window.location.pathname + (qs ? '?' + qs : '');
  }
  if (applyBtn) applyBtn.addEventListener('click', applyFilters);
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); applyFilters(); });

  /* ESC + focus trap */
  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') {
      var f = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, summary');
      var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
